import React from "react";
import { Stack } from "@mui/material";

const AvailablePayments = ({ ...rest }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      mb={2}
      {...rest}
    >
      <img
        src="/img/pm/visa.svg"
        alt="Visa"
        height={38}
        width={38}
        loading="lazy"
        decoding="async"
      />
      <img
        src="/img/pm/MasterCard.svg"
        alt="MasterCard"
        height={38}
        width={38}
        loading="lazy"
        decoding="async"
      />
      <img
        src="/img/pm/Apple_Pay.svg"
        alt="Apple Pay"
        height={38}
        width={38}
        loading="lazy"
        decoding="async"
      />
      <img
        src="/img/pm/googlepay.svg"
        alt="Google Pay"
        height={38}
        width={38}
        loading="lazy"
        decoding="async"
      />
      <img
        src="/img/pm/klarna.svg"
        alt="Klarna"
        height={38}
        width={38}
        loading="lazy"
        decoding="async"
      />
      <img
        src="/img/pm/paypal.svg"
        alt="PayPal"
        height={38}
        width={38}
        loading="lazy"
        decoding="async"
      />
    </Stack>
  );
};

export default AvailablePayments;
